import {Component} from "react";
import {IActionBase} from "./IActionBase";
import {ActionsManager} from "./actionsManager";
import {sendApplyooComponentsNotification} from "../infrastructure/useApplyooComponent";
import {store} from "../../redux/storeConfig/store";
import {dataUtils} from "../js/dataUtils";
import {utils_ui} from "../utils/utils_ui";
import {callPostService} from "../services/api_service";
import {webResponseObject} from "../services/webResponseResponse";


export class action_Tasker_ClearDataAfterDuplicateTask extends Component implements IActionBase {
    actionCode = "action_Tasker_ClearDataAfterDuplicateTask";
    actionName = "Taskeem - Clear Data After Duplicate Recurring Task";

    Execute = (prmActionParameters: any, prmActionsManager: ActionsManager, prmElementObj?: any) => {

        const dataBindStr = prmActionParameters?.DataBindStr

        if (!!dataBindStr) {
            let taskObj = utils_ui.getDataItem(dataBindStr)

            if (!!taskObj) {
                taskObj.TaskID = -1;
                taskObj.StartDT = new Date();
                taskObj.ActualHours = 0;
                taskObj.IsClosed = false;
                taskObj.DeliveryDT = null;
                taskObj.Indicator_EstimatedHoursLimit= null;
                taskObj.Indicator_DueDateLimit = 0;
                taskObj.Indicator_NumTaskComments = 0;
                taskObj.Indicator_NumMultipleAssigneeUsers = 0;
                taskObj.Indicator_NumDueDateChanges = 0;
                taskObj.Indicator_NumReopened = null;
                taskObj.Indicator_IsEstimatedHoursLimitOverdue = false;
                taskObj.Indicator_IsDueDateLimitOverdue = false;
                taskObj.Indicator_IsDueDateChanges = false;
                taskObj.Indicator_IsReopened = false;
                taskObj.LastIndicatorProcessDT = null;
                taskObj.IsActiveRemainder = false;
                taskObj.NextRemainderDT = null;
                taskObj.RemainingHours = null;
                taskObj.RemainingHoursUpdatedDT = null;
                taskObj.RemainingHoursUpdatedByUserID = null;
                taskObj.ExecutionScore = null;
                taskObj.OriginalDueDT = null;
                taskObj.SupervisedRemainderDT = null;
                taskObj.SupervisedByUserID = null;
                taskObj.IsSupervisedDone = null;
                taskObj.SupervisionDT = null;
                taskObj.IsContainsException = false;

                utils_ui.setDataItem(dataBindStr,taskObj)
            }
        }

        // let params = {
        //     prmProjectID: store.getState().store_ProjectData.projectID,
        //     prmDeveloperKey: "ServerAction_RefreshList",
        //     prmParamsDic: {
        //         ListNames: prmActionParameters?.ListNames,
        //     }
        // };
        //
        // callPostService("Asset_ExecuteServerAction", params).then((prmResponse: webResponseObject) => {
        //     if (!!prmResponse?.reponseObj?.IsValid && prmResponse?.reponseObj?.IsValid == "true") {
        //         utils_ui.showToaster(utils_ui.getLanguageTitle('Message_JobCompletedSucessfully'), 'succeed')
        //     }
        //     else if (prmResponse?.reponseObj?.IsValid == "false") {
        //         utils_ui.showToaster(utils_ui.getLanguageTitle('Message_JobFailed'), 'error')
        //     }
        //
        //     //prmCallbackFunction(lstFavoriteTasks);
        //
        // })
    }

}